import { useParams } from 'react-router-dom';
import { ItemListingLabel } from './ItemListingLabel';

export function ItemListingPrintWrapper() {
    const { id } = useParams();

    return (
        <ItemListingLabel itemListingId={id} />
    );
}